import { type Result, ResultStatus } from '@carvana/merch-result';
import { httpWithAuth } from '~/clients';
import { getAuthenticatedRecentVehicles } from '~/constants/endpoints';
import type { RecentVehicle } from '~/contracts/home';

export type RecentVehiclesRequest = {
  browserCookieId: string;
  correlationId: string;
  count: number;
  userId?: string;
};

export type RecentVehiclesResponse = Result<{
  recentVehicles: RecentVehicle[];
}>;

export default async function fetchAuthenticatedRecentVehicles(
  { browserCookieId, correlationId, count }: RecentVehiclesRequest,
  controller: AbortController
): Promise<RecentVehiclesResponse> {
  const query = new URLSearchParams({
    browserCookieId,
    count: String(count)
  });

  const { data } = await httpWithAuth.get<{ vehicles?: RecentVehicle[] }>(
    `${getAuthenticatedRecentVehicles}?${query.toString()}`,
    {
      headers: { 'x-correlation-id': correlationId },
      signal: controller.signal
    }
  );

  return {
    content: { recentVehicles: data.vehicles ?? [] },
    status: ResultStatus.Succeeded
  };
}
